import { apiUrl } from "../../apiClient"; 
import { endpoint } from "../endpoint";
import { customBaseQuery } from "../customBaseQuery";
const { createApi } = require("@reduxjs/toolkit/query/react");

export const sap_api = createApi({
  reducerPath: "sap",
  baseQuery: customBaseQuery,

  endpoints: (builder) => ({
    getAllSAP: builder.query({
      query: () => `${endpoint.sap}`,
    }),
  }),
});

export const { useGetAllSAPQuery } = sap_api;
